import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

// Backward-compatibility shim. The app now addresses detail views by query param
// (/spells?slug=fireball — see EntityRoute) and never generates path-based detail
// URLs. But old bookmarks / indexed links / inbound SEO — and the legacy links
// embedded in imported 3.5e content (e.g. a class feature linking
// /spells/players-handbook-v35--6/summon-monster-i--2441/) — still point at the
// old path form, so we redirect those to the canonical query form instead of
// 404ing them (GitHub issue #48).
//
// The legacy form suffixes each path segment with a `--<numeric id>` (both the
// rulebook and the slug). Current slugs never carry that suffix, so strip a
// trailing `--<digits>` to recover the real slug; without this the redirect
// would carry the bogus id into ?slug= and the detail lookup would still 404.
const stripLegacyId = (s) => (s ? s.replace(/--\d+$/, '') : s);

export default function LegacyDetailRedirect({ base }) {
  const { slug, rulebookSlug } = useParams();
  const params = new URLSearchParams();
  if (slug) params.set('slug', stripLegacyId(slug));
  if (rulebookSlug) params.set('rulebook', stripLegacyId(rulebookSlug));
  return <Navigate to={`${base}?${params.toString()}`} replace />;
}
